import script from "./RolesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RolesModal.vue?vue&type=script&setup=true&lang=ts"

import "./RolesModal.vue?vue&type=style&index=0&id=92fce0f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92fce0f8"]])

export default __exports__